<style>
  .contents .Customer {
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;
  width: 100%;
}
.Customers .cus_list {
  text-align: center;
}

  .datePicker {
    margin-right: 24px;
    width: 380px;
    border-radius: 20px !important;
  }
  .inputSearch {
    width: 260px;
    margin-right: 10px;
  }
  .el-button--success{
    color: #fff;
    background-color: #14C8B5;
    border-color: #14C8B5;
  }
  .el-button--success:focus,.el-button--success:hover{
    background:#3ED6C9;border-color:#3ED6C9;color:#fff
  }

  .Customers .table-list {
    margin: 0 auto;
  }
 .Customers .el-table td, .el-table th {
    padding: 8px 0;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: center;
}
.Customers .inputSearch .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 20px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
</style>
<template>
  <div>
    <div class="contents Customers">
      <div class="cus_list">
        <div class="customers-info">
          <el-row>
            <el-input class='inputSearch' v-model="serviceName" placeholder="输入关键字搜索"></el-input>
            <el-button type='primary' style='margin-right: 180px;' @click="getContractPa">搜索</el-button>
          </el-row>
          <div class="table-list" style="margin-top: 20px">
            <el-table ref='table' :data="tableData" :header-cell-style="{background:'#f5f8fa'}" border max-height="425" :cell-style="{height:'42px'}" style="width: 100%" id="out-table" @row-click="rowClickMet">
              <el-table-column prop='serviceName' label="商品名称" show-overflow-tooltip align="center"></el-table-column>
              <el-table-column prop='price' label="建议零售价" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {selectDCStoreServiceList} from '@/api';
import Vue from 'vue'
export default {
  data() {
    return {
      tableData: [], // 表格数据
	    serviceName:'',
    }
  },
  created() {
     this.getContractPa();
  },
  methods: {
	rowClickMet(row, column, event){
	 this.$emit('rowClicks',row);
	},
  getContractPa(){
    selectDCStoreServiceList({
      serviceName:this.serviceName,
      serviceType:2,
	  storeCode:this.$store.state.userInfo.storeCode	  
      }).then(res=>{
      if(res.code == 1){
        this.tableData = res.data;
      }
    })
  },

 }
};
</script>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/severRelation.vue